const Form042EN = {
    stepName: {
        Statement: "Important Notes",
        PartI: "Part I",
        PartII: "Part II",
        PartIII: "Part III",
        Confirmation: "Confirmation",
    },
    label: {
        applicantOption: {
            individual: "Individual",
            organisation: "Organisation Represented",
        },
        identityOption: {
            HKIC: "HKIC No.",
            passportNo: "Passport No.",
        },
        declareTypeOption: {
            individual: "as an individual",
            organisation: "on behalf of the organization",
        },
        declareTypeOptionPartII: {
            individual: "",
            organisation: "on behalf of the organization",
        },
        // stafPostOption: {
        //     ChildCareSupervisor: "Child Care Supervisor",
        //     ChildCareWorker: "Child Care Worker",
        // },
        submitOption: {
            submitted: "Submitted",
            notYetSubmitted: "Not yet submitted",
        },
        submitOption2: {
            submitted: "Submitted",
            notYetSubmitted: "Not yet submitted",
            notApplicable: "N/A (only provide half-day service)",
        },
        IsHolderOption: {
            true: "Yes",
            false: "No",
        },
        workTimeOption: {
            AMWork: "AM Session",
            PMWork: "PM Session",
            fullWork: "Full Time",
        },
        issuingUnitOption: {
            directorBuilding: "The Director of Buildings",
            directorHousing: "The Director of Housing",
            directorArchitecturalServices:
                "The Director of Architectural Services",
        },
        WROption: {
            WR1: "Work Completion Certificate (WR1 Form) and Certificate of Registration of Electrical Worker and Certificate of Registration of Electrical Contractor",
            WR2: "Periodic Test Certificate (WR2 Form) for fixed electrical installation",
        },
        gasInstallationOption: {
            completion: "Certificate of Completion",
            inspection: "Certificate of Annual Inspection/Maintenance",
        },
        titleOption: {
            Mr: "Mr",
            Mrs: "Mrs",
            Miss: "Miss",
            Ms: "Ms",
        },
        note: "Important Notes",
        statement: "Statement",
        applicationType: "Please select application type:",
        termsConditions:
            "I have read, understood and agreed to the above terms and conditions.",
        termsConditions1:
            'I understand the applicant need to have an "iAM Smart+" account to process the application.',
        applicationTitle: "Title of Applicant:",
        applicationEnglishName: "Name of Applicant(English)",
        applicationChineseName: "Name of Applicant(Chinese)",
        HKIC: "HKIC No.",
        passportNo: "Passport No.",
        organisationEnglishName: "Name of Organisation Represented(English)",
        organisationChineseName: "Name of Organisation Represented(Chinese)",
        addressEnglish: "Address of {{applicationType}}(English)",
        addressChinese: "Address of {{applicationType}}(Chinese)",
        tel: "Tel. No. of {{applicationType}}",
        fax: "Fax No. of {{applicationType}}",
        isSameAbove: "Contact Person same as above",
        contactTitle: "Title of Contact Person:",
        // contactEnglistName: "Name of Contact Person(English)",
        // contactChineseName: "Name of Contact Person(Chinese)",
        contactName: "Name of Contact Person",
        // contactEnglishAddress: "Correspondence Address(English)",
        // contactChineseAddress: "Correspondence Address(Chinese)",
        contactAddress: "Correspondence Address",
        contactTel: "Tel. No. of Contact Person",
        contactFax: "Fax No. of Contact Person",
        contactEmail: "Email Address of Contact Person",
        declareType:
            "With reference to section 7 of the Child Care Services Ordinance Cap. 243, I, <u>{{type}}</u> hereby apply for the premises specified below to be registered as a child care centre.",
        registerEnglishName: "Name of Proposed Centre(English)",
        registerChineseName: "Name of Proposed Centre(Chinese)",
        registerEnglishAddress: "Full Address of Proposed Centre(English)",
        registerChineseAddress: "Full Address of Proposed Centre(Chinese)",
        registerTel: "Tel. No. of Proposed Centre",
        registerFax: "Fax No. of Proposed Centre",
        registerEmail: "Email Address of Proposed Centre",

        sectionOne: "1. Nature of Service, Proposed Capacity and Proposed Fee",
        sectionTwo: "2. Staff List:",

        centerType: "Type of Centre",
        capacityNum: "Proposed Capacity",
        crecheGp: "Creche(0-2)",
        nurseryGp: "Nursery(2-3)",
        amProp: "AM Session",
        pmProp: "PM Session",
        fullProp: "Full Day",
        feeNum: "Proposed Fee per month and No. of Instalments",
        amFee: "AM Session(No. of Instal.)",
        pmFee: "PM Session(No. of Instal.)",
        fullFee: "Full Day(No. of Instal.)",
        mealCharge: "Meal Charge(No. of Instal.)",

        // staffPost: "Post",
        childCareSupervisor: "Child Care Supervisor",
        childCareWorker: "Child Care Worker",
        staffEnglishName: "Name of English",
        staffChineseName: "Name of Chinese",
        // staffHKICNo: "HKIC No.",
        // staffPassportNo: "Passport No.",
        workingHours: "Working Hours:",
        holderCertificate: "Holder of Valid First Aid Certificate:",
        AidCertificateFile: "Attachment(First Aid Cert):",

        sectionThree:
            "3. Time-table:The proposed time-table of daily activities of the centre",
        sectionFour1: "4. Dietary Scale and menu",
        sectionFour2: ":The proposed dietary scale and menu",
        sectionFive: "5. Admission plan",
        submitChoose: "Submitted or not:",

        timeTableFile: "Upload daily activity schedule",
        menuDietaryFile: "Upload dietary scale and menu",
        childrenNo: "No. of children to be admitted in Initial Stage",
        staffNo: "No. of Child Care Staff in Initial Stage",
        sectionSixHeader: "6. Relevant Certificates/Documents attached: ",
        sectionSixA:
            "(a) Copy of Certificate from the Director of Fire Services",
        sectionSixB:
            "(b) Copy of Certificate from the Director of Buildings/Director of Housing/Director of Architectural Services",
        sectionSixC:
            "(c) Copy of Work Completion Certificate (WR1 Form) plus a copy each of the Certificates of Registration of Electrical Worker and Electrical Contractor and/or* Periodic Test Certificate (WR2 Form) for fixed electrical installation",
        sectionSixD:
            "(d) The Certificate of Completion or Certificate of Annual Inspection/Maintenance in duplicate for gas installation work*, if necessary, plus a copy each of the Gas Installer Registration Card and Certificate of Registration of Gas Contractor",

        referenceFire: "Reference",
        issueDateFire: "Date of issue",
        fireCertificatFile: "Certificate:",

        selectUnit: "Issued by:",
        referenceBuild: "Reference",
        issueDateBuild: "Date of issue",
        buildCertificatFile: "Certificate:",

        // selectWR: "Select the file to upload",
        electricalContractorNo: "Registration no. of electrical contractor",
        completeDate: "Date of completion",
        WCCertificatFile: "Work Completion Certificate (WR1 Form):",
        REWCertificatFile: "Certificate of Registration of Electrical Worker:",
        ECCertificatFile:
            "Certificate of Registration of Electrical Contractor:",
        PTCCertificatFile:
            "Periodic Test Certificate (WR2 Form) for fixed electrical installation:",

        // selectGas: "select gas installation work",
        gasContractorNo: "Registration no. of gas contractor",
        gasCompleteDate: "Date of completion",
        CGIWCertificatFile:
            "Certificate of Completion for gas installation work or Certificate of Annual Inspection/Maintenance for gas installation work form:",
        // AIMGIWCertificatFile:
        //     "Certificate of Annual Inspection/Maintenance for gas installation work:",
        GIRCRCertificatFile: "Gas Installer Registration Card:",
        RGCCRertificatFile: "Certificate of Registration of Gas Contractor:",
    },
    errorMsg: {
        propTotal:
            "The total number of Proposed Capacity must be greater than 1",
        feeTotal: "The total number of Proposed Fee must be greater than 1",
        addToast:
            "Please fill in the information of the above child care worker",
        addToast2: "Please remove the blank record of the child care worker",
        "E-A-001": "Only one child supervisor can be added",
    },
    notesList: {
        note1: "Please see Regulation 5 and Regulation 6 of the Child Care Services Regulations, Cap.243",
        note2: "Please enclose a copy of valid First Aid Certificate of the holder",
        // note3: "Delete if the centre runs half-day sessions",
    },

    statement: {
        titleList: [{ text: "Important Notes" }],
        fourStep: [
            {
                text: 'Applicant without an "iAM Smart+" account is required to return the completed form to Joint Office for Kindergartens and Child Care Centres for processing (Address: Room 602, 6/F, 14 Taikoo Wan Road, Taikoo Shing, Hong Kong).　Please ensure that sufficient postage is paid to avoid unsuccessful delivery. Any underpaid mail items will be disposed of by the Hongkong Post.',
            },
        ],
    },
};
export default Form042EN;
